import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '商品分类',
    auth: true,
    authorityValue: "store-store-subcate"
  },
  name: 'tabTrade',
  data: function data() {
    return {
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.data_bind();
  },
  methods: {
    data_bind: function data_bind(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, total, records;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.storeGoodsTypes(_objectSpread(_objectSpread({}, data), {}, {
                  typeLevel: 1
                }));

              case 2:
                res = _context.sent;
                total = res.total, records = res.records;
                _this.total = total;
                _this.tableData = records;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    pagination: function pagination(item) {
      this.data_bind(item);
    },
    handleNav: function handleNav(NAME, row) {
      this.$router.push({
        name: NAME,
        query: row ? row : ''
      });
    },
    deleteStoreGoodsType: function deleteStoreGoodsType(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.deleteStoreGoodsType(data);

              case 2:
                _this2.$notify.success({
                  title: '成功',
                  message: '成功删除'
                });

                _this2.data_bind();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};